// src/utils/solicitorValidation.js

/**
 * 募集人フォームのバリデーションを実行
 * @param {Object} solicitorForm - 募集人フォームのデータ
 * @param {string} solicitorForm.name - 担当者名
 * @param {string} solicitorForm.branchName - 支店名
 * @param {string} solicitorForm.startDate - 開始日
 * @param {string} solicitorForm.accountname - アカウント名（メールアドレス）
 * @returns {Object} バリデーション結果 { isValid: boolean, errors: string[] }
 */
export const validateSolicitorForm = (solicitorForm, isMasked = false) => {
  const errors = [];
  const { name, branchName, startDate, accountname } = solicitorForm;

  // 担当者名漢字チェック
  if (!name?.trim()) {
    errors.push('担当者名漢字を入力してください。');
  }

  // 支店名チェック
  if (!branchName?.trim()) {
    errors.push('支店名を入力してください。');
  }

  // アカウント名チェック
  if (!accountname?.trim()) {
    errors.push('メールアドレス（アカウント名）を入力してください。');
  }

  // 開始日チェック
  // 代理店ユーザの場合、開始日を編集できないのでチェックしない（
  if (isMasked && !startDate?.trim()) {
    errors.push('開始日を入力してください。');
  }

  return {
    isValid: errors.length === 0,
    errors: errors
  };
};

/**
 * バリデーション結果を表示する共通関数（alert版）
 * @param {Object} validationResult - validateSolicitorForm の戻り値
 * @param {Function} displayMethod - エラー表示方法（デフォルトはalert）
 * @returns {boolean} バリデーション成功の場合 true
 */
export const displayValidationErrors = (validationResult, displayMethod = alert) => {
  if (!validationResult.isValid) {
    displayMethod(validationResult.errors.join('\n'));
    return false;
  }
  return true;
};

/**
 * バリデーション結果をErrorDialogで表示する関数（useErrorDialogと連携）
 * @param {Object} validationResult - validateSolicitorForm の戻り値
 * @param {Function} showError - useErrorDialog から取得したshowError関数
 * @returns {boolean} バリデーション成功の場合 true
 */
export const displayValidationErrorsWithDialog = (validationResult, showError) => {
  if (!validationResult.isValid) {
    showError({
      message: validationResult.errors.join('\n'),
      type: 'VALIDATION_ERROR',
      // statusCodeを明示的に422（バリデーションエラー）に設定
      statusCode: 422,
      error: {
        type: 'VALIDATION_ERROR',
        code: 'VALIDATION_FAILED'
      }
    });
    return false;
  }
  return true;
};

/**
 * バリデーション結果をグローバルErrorDialogで表示する関数（グローバル関数使用）
 * @param {Object} validationResult - validateSolicitorForm の戻り値
 * @returns {boolean} バリデーション成功の場合 true
 */
export const displayValidationErrorsGlobal = (validationResult) => {
  if (!validationResult.isValid) {
    // 動的インポートでshowGlobalErrorDialogを取得（循環参照を避けるため）
    import('../providers/ErrorDialogProvider').then(({ showGlobalErrorDialog }) => {
      showGlobalErrorDialog({
        message: validationResult.errors.join('\n'),
        type: 'VALIDATION_ERROR',
        // statusCodeを明示的に422（バリデーションエラー）に設定
        statusCode: 422,
        error: {
          type: 'VALIDATION_ERROR',
          code: 'VALIDATION_FAILED'
        }
      });
    });
    return false;
  }
  return true;
};